import { IExtendendJsonSchemaDestination } from '@homex/se-widget-flow-types';

import { ajv } from 'utils/ajv';

export const resolveSeDestination = (
  destinations: Array<IExtendendJsonSchemaDestination>,
  data: any,
) => {
  const destination = destinations.reduce((prev, current) => {
    if (!data) return '';

    const validate = ajv.compile(current);
    const valid = !!validate(data);

    return valid ? current.navigateTo : prev;
  }, '');

  return destination;
};
